import React from 'react';

import Button from '@atlaskit/button';
import DropdownMenu, { DropdownItem } from '@atlaskit/dropdown-menu';

import TestTypePopupSelectOption from '@qality/common-components/src/atoms/TestTypePopupSelectOption/TestTypePopupSelectOption';
import { TestTypeComponent } from '@qality/common-components/src/molecules/TestTypeComponent';
import { TestType, TestTypeAppearance } from '@qality/common-model';
import { useTestTypesContext } from '@qality/common-pages';

import { useTestTypePopupSelectContext } from './TestTypePopupSelectProvider';

type Props = {
  defaultTestType?: TestType;
  appearance?: TestTypeAppearance;
};

export default function TestTypePopupSelect({ appearance = 'subtle' }: Props) {
  const { testTypes } = useTestTypesContext();

  const { selectedTestType, setSelectedTestType } =
    useTestTypePopupSelectContext();

  return (
    <DropdownMenu
      trigger={({ triggerRef, ...triggerProps }) => (
        <Button
          {...triggerProps}
          ref={triggerRef}
          spacing='compact'
          appearance='subtle'
          style={{
            padding: '0px',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <TestTypeComponent
            isIconOnly
            testType={selectedTestType}
            appearance={appearance}
            showTooltip
          />
        </Button>
      )}
    >
      {testTypes.map((testType) => (
        <DropdownItem
          key={`test-type-option-${testType.id}`}
          onClick={() => setSelectedTestType(testType)}
        >
          <TestTypePopupSelectOption testType={testType} />
        </DropdownItem>
      ))}
    </DropdownMenu>
  );
}
